import {
    BellOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    CreditCardFilled,
    EditOutlined,
    ExclamationCircleFilled,
    FileTextOutlined,
} from '@ant-design/icons';
import {
    Button,
    Card,
    Col,
    ConfigProvider,
    Modal,
    Row,
    Space,
    Spin,
    Tabs,
    Tag,
    Typography
} from 'antd';
import frFR from "antd/locale/fr_FR";
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Footer from '../../components/Footer';
import NavBar from '../../components/NavBar';
import SideBar from '../../components/SideBar';
import { useBreadcrumbTitle } from '../../contexts/BreadcrumbContext';
import { frenchDate, frenchDateSimple } from '../../variables/functions';
import EditIntermediaire from './EditIntermediaire';
import SetupIntermediaireUserAccount from './SetupIntermediaireUserAccount';
import axiosInstance from '../../variables/api/axiosInstance';
import ProfilingIntermediaire from './intermediaires/ProfilingIntermediaire';
import ContratsTab from './intermediaires/ContratsTab';
import CommissionsTab from './intermediaires/CommissionsTab';
import { LOGGED_USER } from '../../variables/constants';
const { confirm } = Modal;
const { Title, Text } = Typography;
const { TabPane } = Tabs;

const colors = {
    primary: '#242166',
    secondary: '#1890ff',
    success: '#52c41a',
    warning: '#faad14',
    danger: '#ff4d4f',
    info: '#13c2c2',
    light: '#f0f2f5',
    gradient1: 'linear-gradient(135deg, #242166 0%, #1890ff 100%)',
    gradient2: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    gradient3: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    gradient4: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
};

const DetailsIntermediaire = () => {
    const { setPageTitle } = useBreadcrumbTitle();
    const [intermediaire, setIntermediaire] = useState("");
    const [contrats, setContrats] = useState([]);
    const [loadingContrats, setLoadingContrats] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [reload, setReload] = useState(false);
    const [activeTab, setActiveTab] = useState('1');
    const [userExists, setUserExists] = useState(false);
    const [intermediaireUserAccount, setIntermediaireUserAccount] = useState("");
    const [profils, setProfils] = useState([]);
    const [commissions, setCommissions] = useState([]);
    const [sumCommission, setSumCommission] = useState(0);
    const [validatedContrats, setValidatedContrats] = useState([]);

    const [filteredInfo, setFilteredInfo] = useState({});
    const [sortedInfo, setSortedInfo] = useState({});
    const [selectedContrat, setSelectedContrat] = useState();
    const [selectedContrats, setSelectedContrats] = useState([]);
    const [selecting, setSelecting] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [hiddenMultpleInvoices, setHiddenMultipleInvoices] = useState(false);
    const [hidden, setHidden] = useState(false);
    const [categories, setCategories] = useState([]);
    const [commissionValues, setCommissionValues] = useState({});

    const param = useParams();

    useEffect(() => {
        const label = `${intermediaire?.personne?.prenom || ''} ${intermediaire?.personne?.nom || ''}`.trim()
            || intermediaire?.raisonSociale;
        if (label) setPageTitle(label);
        return () => setPageTitle(null);
    }, [intermediaire]);

    const isAdminProfile = (LOGGED_USER?.profil?.nom || "").toLowerCase().includes("admin");
    const canEditIntermediaire = isAdminProfile;
    const isPoolUser = LOGGED_USER?.profil?.organisme?.typeOrganisme === "POOL";

    const handleEditClose = () => setShowEditModal(false);
    const handleClose = () => setShowModal(false);

    const handleTabChange = (key) => {
        setActiveTab(key);
    };

    useEffect(() => {
        if (param.codeIntermediaire) {

            var ctrs = [];
            axiosInstance
                .get(`/api/intermediaire/codeId/${param.codeIntermediaire}`)
                .then((res) => {
                    console.log(res.data);
                    axiosInstance
                        .get(`/api/profil/organisme/codeOrganisme/${res.data?.organisme?.code}`)
                        .then((resp) => {
                            console.log("Response data: ", resp.data);
                            setProfils(resp.data);
                        })
                        .catch((err) => {
                            console.log(err);
                        });

                    setIntermediaire(res.data);

                    if (res.data.personne.email) {
                        axiosInstance
                            .get(`/api/utilisateur/check/${res.data.personne.email}`)
                            .then((response) => {
                                setUserExists(response.data);
                                if (response.data) {
                                    getIntermediaireUserAccount(res.data.personne.email);
                                }
                            })
                            .catch((err) => {
                                console.log(err);
                            });
                    }

                })
                .catch((err) => {
                    console.log(err);
                });

            axiosInstance
                .get(`/api/contrat/intermediaire/codeId/${param.codeIntermediaire}`)
                .then((res) => {
                    //   console.log(res.data);
                    let vCtrs = [];
                    let coms = [];
                    let comKeys = [];
                    let valueCommission = 0;
                    const seenReglementIds = new Set();
                    res.data.forEach((contrat, key) => {
                        if (contrat.reglements && contrat.reglements.length) {
                            contrat.reglements.forEach((reg) => {
                                if (seenReglementIds.has(reg.codeId)) return;
                                seenReglementIds.add(reg.codeId);
                                reg.montant < 0 && !reg.commissionPaye && comKeys.push(reg.codeId);
                                coms.push({
                                    key: reg.codeId,
                                    codeId: reg.codeId,
                                    id: reg.codeId,
                                    numeroPolice: contrat.numeroPoliceP,
                                    souscripteur: contrat?.souscripteur?.prenom
                                        ? `${contrat?.souscripteur?.prenom} ${contrat?.souscripteur?.nom}`
                                        : `${contrat?.souscripteur?.nom}`,
                                    organisme: contrat.organisme.raisonSociale,
                                    dateEffet: contrat?.dateEffet
                                        ? `${frenchDate(contrat?.dateEffet)}`
                                        : "",
                                    dateEcheance: contrat?.dateEcheance
                                        ? `${frenchDateSimple(contrat?.dateEcheance)} `
                                        : "",
                                    regle: reg.dateReglement
                                        ? "REGLE"
                                        : "NON REGLE",
                                    data: reg,
                                    contrat: contrat
                                });
                                valueCommission += reg.commission ? reg.commission : 0;
                            })
                        }

                        contrat.statutContrat === "VALIDE" && vCtrs.push(contrat);

                        ctrs.push({
                            key: contrat.codeId,
                            codeId: contrat.codeId,
                            id: key,
                            numeroPolice: contrat.numeroPoliceP,
                            souscripteur: contrat?.souscripteur?.prenom
                                ? `${contrat?.souscripteur?.prenom} ${contrat?.souscripteur?.nom}`
                                : `${contrat?.souscripteur?.nom}`,
                            organisme: contrat.organisme.raisonSociale,
                            dateEffet: contrat?.dateEffet
                                ? `${frenchDate(contrat?.dateEffet)}`
                                : "",
                            dateEcheance: contrat?.dateEcheance
                                ? `${frenchDateSimple(contrat?.dateEcheance)} `
                                : "",
                            regle: contrat.reglements
                                ? contrat.reglements.length
                                    ? "REGLE"
                                    : "NON REGLE"
                                : "NON REGLE",
                            data: contrat,
                        });
                        // console.log("CTRS: ", ctrs);
                    });

                    let _coms = coms.filter(e => e.data.montant < 0 && !e.data.commissionPaye);
                    console.log("____Commmmss:", _coms);
                    setSelectedContrats(_coms);
                    setSelectedRows(_coms);
                    setSelectedRowKeys(comKeys);
                    setContrats(ctrs);
                    setValidatedContrats(vCtrs);
                    setCommissions(coms);
                    setSumCommission(valueCommission);
                    setLoadingContrats(false);
                })
                .catch((err) => {
                    console.log(err);
                    setLoadingContrats(false);
                });
        }

        axiosInstance
            .get(`/api/categorie`)
            .then((res) => {
                const filtered = res.data.filter((e) => !e.codeCategorie.startsWith("V") && e.codeCategorie !== "MO");
                setCategories(filtered);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [param.codeIntermediaire, reload, showModal, showEditModal]);

    useEffect(() => {
        if (categories.length && intermediaire?.tauxCommission) {
            setCommissionValues((prev) => {
                const mapped = { ...prev };
                categories.forEach((cat) => {
                    const match = intermediaire.tauxCommission.find(
                        (tc) => tc?.categorie?.codeCategorie === cat.codeCategorie
                    );
                    if (match) {
                        mapped[cat.codeCategorie] = match.taux;
                    } else if (mapped[cat.codeCategorie] === undefined) {
                        mapped[cat.codeCategorie] = 0;
                    }
                });
                return mapped;
            });
        }
    }, [categories, intermediaire]);

    const codeApporteur = intermediaire?.codeIntermediaire || intermediaire?.code || '--';
    const activationIcon = intermediaire?.active ? <CloseCircleOutlined /> : <CheckCircleOutlined />;
    const activationLabel = intermediaire?.active ? 'Suspendre' : 'Activer';


    const getIntermediaireUserAccount = (email) => {
        axiosInstance
            .get(`/api/utilisateur/session/${email}`)
            .then((resp) => {
                setIntermediaireUserAccount(resp.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    const handleChange = (pagination, filters, sorter) => {
        console.log("Various parameters", pagination, filters, sorter);
        setFilteredInfo(filters);
        setSortedInfo(sorter);
    };

    const onSelectChange = (newSelectedRowKeys, rows) => {
        console.log("selectedRowKeys changed: ", newSelectedRowKeys);
        console.log("SelectedRows", rows);
        setSelecting(true);
        setSelectedRows(rows);
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const activateIntermediaireConfirm = () => {
        confirm({
            title: `Etes-vous sûr de vouloir ${intermediaire.active ? "désactiver" : "activer"} cet intermédiaire?`,
            icon: <ExclamationCircleFilled />,
            content: "Toutes vos actions sont historisées!",
            okText: "Oui",
            okType: "danger",
            cancelText: "Annuler",
            onOk() {
                console.log("OK");
                activateIntermediaire();
            },
            onCancel() {
                console.log("Cancel");
            },
        });
    };

    const activateIntermediaire = () => {
        axiosInstance
            .get(`/api/intermediaire/activity/${intermediaire.codeIntermediaire}`).then((res) => {
                console.log(res.data);
                intermediaire.codeIntermediaire ? toast("Intermédiaire désactivé avec succès!") : toast("Intermédiaire activé avec succès!");
                setReload((prev) => !prev);
            }).catch(err => {
                console.log(err);
                intermediaire.codeIntermediaire ? toast("Erreur lors de la désactivation de l'intermédiaire") : toast("Erreur lors de l'activation de l'intermédiaire");
            });
    }

    return (
        <>
            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    <SideBar currentMenu="MEMBRES" />
                    <div className="layout-page">
                        <NavBar />
                        <div className="content-wrapper">
                            <div className="container-xxl flex-grow-1 container-p-y">
                                <div style={{ background: colors.light, minHeight: '100vh', padding: 24 }}>
                                    <Card
                                        bordered={false}
                                        style={{
                                            marginBottom: 24,
                                            background: colors.gradient1,
                                            borderRadius: 12,
                                            boxShadow: '0 10px 30px rgba(36,33,102,0.2)'
                                        }}
                                    >
                                        <Row align="middle" justify="space-between" gutter={[16, 16]}>
                                            <Col>
                                                <Space direction="vertical" size={0}>
                                                    <Text style={{ color: 'white', fontSize: 16, opacity: 0.8 }}>
                                                        Code intermédiaire
                                                    </Text>
                                                    <Title level={2} style={{ color: 'white', margin: 0 }}>
                                                        #{codeApporteur}
                                                    </Title>
                                                    <Tag
                                                        color={intermediaire?.personne?.typePersonne === 'MORALE' ? 'gold' : 'cyan'}
                                                        style={{ borderRadius: 6, fontWeight: 600, marginTop: 4 }}
                                                    >
                                                        {intermediaire?.personne?.typePersonne === 'MORALE' ? 'Personne morale' : 'Personne physique'}
                                                    </Tag>
                                                    <Text style={{ color: 'white', fontSize: 14, opacity: 0.8 }}>
                                                        Date d'ajout : {frenchDate(intermediaire?.createdAt)}
                                                    </Text>
                                                </Space>
                                            </Col>
                                            <Col>
                                                <Space wrap>
                                                    {canEditIntermediaire && (
                                                        <Button
                                                            type="primary"
                                                            icon={<EditOutlined />}
                                                            size="large"
                                                            onClick={() => setShowEditModal(true)}
                                                            style={{ borderRadius: 8, backgroundColor: 'white', color: colors.primary, borderColor: 'white' }}
                                                        >
                                                            Modifier
                                                        </Button>
                                                    )}
                                                    <Button
                                                        danger={intermediaire?.active}
                                                        type={intermediaire?.active ? 'default' : 'primary'}
                                                        icon={activationIcon}
                                                        size="large"
                                                        onClick={() => activateIntermediaireConfirm()}
                                                        style={{ borderRadius: 8, borderColor: "white" }}
                                                    >
                                                        {activationLabel}
                                                    </Button>
                                                </Space>
                                            </Col>
                                        </Row>
                                    </Card>

                                    <Row gutter={[24, 24]}>
                                        <Col xs={24} lg={8}>
                                            <Card bordered={false} style={{ borderRadius: 12 }}>
                                                <ProfilingIntermediaire intermediaire={intermediaire} userExists={userExists} categories={categories} setReload={setReload} validatedContrats={validatedContrats} sumCommission={sumCommission} commissionValues={commissionValues} setCommissionValues={setCommissionValues} setShowModal={setShowModal} canEditRates={!isPoolUser} />
                                            </Card>
                                        </Col>

                                        <Col xs={24} lg={16}>
                                            <Card bordered={false} style={{ borderRadius: 12 }}>
                                                <Tabs activeKey={activeTab} onChange={handleTabChange} size="large">
                                                    <TabPane
                                                        tab={
                                                            <span>
                                                                <FileTextOutlined />
                                                                Contrats
                                                            </span>
                                                        }
                                                        key="1"
                                                    >
                                                        <div className="card-datatable table-responsive">
                                                            <ConfigProvider locale={frFR}>
                                                                <Spin spinning={loadingContrats}>
                                                                    <ContratsTab contrats={contrats} handleChange={handleChange} sortedInfo={sortedInfo} filteredInfo={filteredInfo} />
                                                                </Spin>
                                                            </ConfigProvider>
                                                        </div>
                                                    </TabPane>
                                                    <TabPane
                                                        tab={
                                                            <span>
                                                                <CreditCardFilled />
                                                                Commissions
                                                            </span>
                                                        }
                                                        key="2"
                                                    >
                                                        <CommissionsTab loadingContrats={loadingContrats} commissions={commissions} handleChange={handleChange} selecting={selecting} selectedContrat={selectedContrat} setSelectedContrat={setSelectedContrat} selectedContrats={selectedContrats} hidden={hidden} setHidden={setHidden} filteredInfo={filteredInfo} sortedInfo={sortedInfo} hiddenMultpleInvoices={hiddenMultpleInvoices} selectedRows={selectedRows} setSelectedContrats={setSelectedContrats} setHiddenMultipleInvoices={setHiddenMultipleInvoices} rowSelection={rowSelection} />
                                                    </TabPane>
                                                    <TabPane
                                                        tab={
                                                            <span>
                                                                <BellOutlined />
                                                                Notifications
                                                            </span>
                                                        }
                                                        key="3"
                                                    >
                                                        <Card bordered={false} style={{ borderRadius: 12, background: '#fff' }}>
                                                            <Text type="secondary">Aucune notification pour le moment.</Text>
                                                        </Card>
                                                    </TabPane>
                                                </Tabs>
                                            </Card>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            <Footer />
                            <div className="content-backdrop fade"></div>
                        </div>
                    </div>
                </div>
                <div className="layout-overlay layout-menu-toggle"></div>
                <div className="drag-target"></div>
            </div>
            <EditIntermediaire
                show={showEditModal}
                handleClose={handleEditClose}
                intermediaire={intermediaire}
                agence={intermediaire?.agence}
            />
            <SetupIntermediaireUserAccount
                show={showModal}
                handleClose={handleClose}
                intermediaire={intermediaire}
                profils={profils}
            />
        </>
    );
}

export default DetailsIntermediaire
